import store from '../store'
import {CommonApi} from '../request/common_api'

// 性别类型
function getGenderType () {
  if (store.state.applyBase.genderType.length) {
    return
  }
  CommonApi.getTableList('GENDER').then(res => {
    if (res.retCode === '0000') {
      store.commit('applyBase/setGenderType', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

// 证件类型
function getCardCertType () {
  if (store.state.applyBase.cardCertType.length) {
    return
  }
  CommonApi.getTableList('IDTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('applyBase/setCardCertType', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

// 商户类型
function getMerchantType () {
  if (store.state.applyBase.merchantType.length) {
    return
  }
  CommonApi.getTableList('MERCHANTTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('applyBase/setMerchantType', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

// 制卡任务类型
function getCardTaskType () {
  if (store.state.applyBase.cardTaskType.length) {
    return
  }
  CommonApi.getTableList('MKCARDTASKTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('applyBase/setCardTaskType', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

// 介质类型
function getMediaType () {
  if (store.state.applyBase.mediaType.length) {
    return
  }
  CommonApi.getTableList('IDMEDIATYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('applyBase/setMediaType', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

// 部门类型
function getDepartmentType () {
  if (store.state.applyBase.departmentType.length) {
    return
  }
  let list = [{codeNo: '0', codeName: '人事部门'}, {codeNo: '1', codeName: '学籍部门'}]
  store.commit('applyBase/setDepartmentType', list)
}

// 设备运维类型
function getDeviceMaintenanceType () {
  if (store.state.applyBase.deviceMaintenanceType.length) {
    return
  }
  CommonApi.getTableList('DEVMNTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('applyBase/setDeviceMiantenanceType', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

// 充值明细报表的交易类型
function getReportTranType () {
  if (store.state.applyBase.reportTranType.length) {
    return
  }
  let sorts = [{
    codeNo: '0101',
    codeName: '现金充值'
  }, {
    codeNo: '0102',
    codeName: '账户充值'
  }, {
    codeNo: '0103',
    codeName: '线上充值'
  }, {
    codeNo: '0104',
    codeName: '预支充值'
  }, {
    codeNo: '1101',
    codeName: '现金充值撤销'
  }, {
    codeNo: '1102',
    codeName: '账户充值撤销'
  }, {
    codeNo: '1103',
    codeName: '线上充值撤销'
  }, {
    codeNo: '1104',
    codeName: '预支充值撤销'
  }]
  store.commit('applyBase/setReportTranType', sorts)
}

let getOptions = {
  getGenderType,
  getCardCertType,
  getMerchantType,
  getCardTaskType,
  getMediaType,
  getDepartmentType,
  getDeviceMaintenanceType,
  getReportTranType
}

export {getOptions}



// WEBPACK FOOTER //
// ./src/util/applyBase_handleOptions.js